import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import BadgeWithIconRounded from "../../../components/badgeWithIconRounded/badgeWithIconRounded";
import ToolTipUsingPortal from "../../../components/toolTipUsingPortal/toolTipUsingPortal";
import { usePayerNameContextFromSingleOrderLayout } from "../../../context/payerNameContextFromSingleOrderLayout";
import { ScreenNamesForBigQuery } from "../../../enums/eventsData";
import { EventsName } from "../../../enums/eventsName";
import { RootState } from "../../../redux/store/store";
import WarningIcon from "../../../svg/warningIcon";
import { generateFullName } from "../../../utils/generateOrderDataForTable";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";

import { apiWorkerManager } from "../../../workerManagers/workerManager";
const MultiplePastRegimenBadge = () => {
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const orgId = getOrgIdForFetchExternalWorklist();
  const { payerName } = usePayerNameContextFromSingleOrderLayout();
  const [showTooltip, setShowTooltip] = useState(false);
  const badgeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    apiWorkerManager.enqueueAndProcess({
      patient_id: singleMedicalPaOrder?.patient_id ?? "",
      order_id: singleMedicalPaOrder?.order_id ?? "",
      org_id: orgId ?? "",
      event_name: EventsName.VIEW_CHECK_VISITS_CAUTIOUSLY,
      user_id: user?.id ?? "",
      user_email: user?.email ?? "",
      additional_data: {
        screen_name: ScreenNamesForBigQuery.AUTH_STATUS_SCREEN,
        source: ScreenNamesForBigQuery.AUTH_STATUS_SCREEN,
        patient_name: generateFullName(
          singleMedicalPaOrder?.demographics?.first_name ?? "",
          "",
          singleMedicalPaOrder?.demographics?.last_name ?? "",
        ),
        patient_mrn: singleMedicalPaOrder?.demographics?.patient_mrn ?? "",
        coverage_type:
          singleMedicalPaOrder?.coverage?.primary?.payer_name ?? "",
        payer_name: payerName,
      },
    });
  }, [singleMedicalPaOrder, user, orgId, payerName]);

  return (
    <div
      className="multiple-past-regimen-badge--container flex items-center justify-center gap-2"
      ref={badgeRef}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <BadgeWithIconRounded
        text={"Check Visits Cautiously"}
        icon={<WarningIcon height="16" width="16" />}
        id="multiple-past-regimen-badge"
        bgColor={"#FFE8E8"}
        textColor={"#0f0f0f"}
        borderColor={"#CC0300"}
      />
      {showTooltip && (
        <ToolTipUsingPortal
          title="Multiple Past Regimens Detected"
          placement="bottom"
          showTooltip={showTooltip}
          parentRef={badgeRef}
          offsetPx={10}
          wrapText
          maxWidth="550px"
        >
          <div>
            Please carefully review the completed and remaining visits,
            including any past completed regimen or flowchart in the treatment
            plan.
          </div>
        </ToolTipUsingPortal>
      )}
    </div>
  );
};

export default MultiplePastRegimenBadge;
